export function getdata() {
	let obj = {
		headData: [
			{
				title: '性质',
				prop: 'parameterProperty',
				width: '120',
				issort: true,
				custom: true,
			},
			{
				title: '税率/征收率',
				prop: 'taxRate',
				width: '220',
				issort: true,
			},
			{
				title: '有效期起',
				prop: 'effectiveDateStart',
				width: '120',
				issort: true,
				custom: true,
			},
			{
				title: '有效期止',
				prop: 'effectiveDateEnd',
				width: '120',
				issort: true,
				custom: true,
			},
			{
				title: '状态',
				prop: 'parameterStatus',
				width: '220',
				showFilter: true,
				custom: true,
				checkList: ['0', '1'],
				dataList: [{
						name: "启用",
						code: "0"
					},
					{
						name: "停用",
						code: "1"
					},
				]
			},
			{
				title: '停用日期',
				prop: 'disableDate',
				width: '220',
				showFilter: true,
				filterType: "daterange",
				checkList: [],
				custom: true,
			},
			{
				title: '是否有原税率',
				prop: 'taxRateLogo',
				width: '160',
				showFilter: true,
				custom: true,
				checkList: ['Y', "N"],
				dataList: [{
						name: "有",
						code: "Y"
					},
					{
						name: "没有",
						code: "N"
					},
				]
			},

			{
				title: '原税率',
				prop: 'correspondingOriginalTaxRate',
				width: '120',
			},
		],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
